export const MenuJson = [
  {
    menu: { name: "Home", link: "/" },
    subMenu: [
      {
        title: "About us",
        link: "/aboutus",
      },
      {
        title: "Blogs",
        link: "https://blog.taksheela.com",
      },
      {
        title: "Taksheela Edge",
        link: "/",
        id: "taksheela-edge-section",
      },
      {
        title: "Taksheela Insights",
        link: "/",
        id: "taksheela-insights-section",
      },
    ],
  },

  {
    menu: { name: "Study Abroad", link: "/study-abroad" },
    subMenu: [
      {
        title: "Test Prep",
        link: "/test",
        id: "test-prep-section",
      },
      {
        title: "Countries",
        link: "/study-abroad/country",
        id: 'countries-section',
      },
      {
        title: "University Finder",
        link: "/study-abroad/universityFinder",
        id: 'university-finder-section',
      },
    ],
  },
  {
    menu: { name: "International Engagement", link: "/international-relation" },
    subMenu: [
      {
        title: "International Student Recruitment",
        link: "/international-relation",
        id:"international-student-recruitment"
      },
      {
        title: "Global Immersion",
        link: "/international-relation",
        id:"global-immersion"
      },
      {
        title: "Student Exchange Semester Abroad",
        link: "/international-relation",
        id:"student-exchange-semester-abroad"
      },
      {
        title: "Collaborative Research & Seminars",
        link: "/international-relation",
        id:"collaborative-research-seminars"
      },
      {
        title: "Dual degree & Twinning Programmes",
        link: "/international-relation",
        id:"twinning-programmes"
      },
      {
        title: "Internship Opportunities",
        link: "/international-relation",
        id:"internship-opportunities"
      },
    ],
  },
];
